import { Security } from "@material-ui/icons"
import React from "react"
import { useSnackbar } from ".."
import { useJobUtils } from "../../utils"
import { TaskActionCard, ProcessActionCard } from "../ActionCards"

const Job = ({ job, click, onView, onEdit, date, compact, cy }) => {
  const { canNavigateToJob } = useJobUtils()
  const snackbar = useSnackbar()

  const navigable = canNavigateToJob(job)

  const handleCantNavigate = () => {
    snackbar.showMessage({
      icon: <Security />,
      message: "Job is in a different location, unable to view",
    })
  }

  if (job.task) {
    return (
      <TaskActionCard
        job={job}
        {...{ click, onView, onEdit, date, compact, navigable, onCantNavigate: handleCantNavigate, cy }}
      />
    )
  }
  return (
    <ProcessActionCard
      job={job}
      {...{ click, onView, onEdit, date, compact, navigable, onCantNavigate: handleCantNavigate, cy }}
    />
  )
}

export { Job }
